import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'

const PanelTests = () => {
  return (
    <div id='website-responsive'  style={{ overflow:'hidden'}}>
    <div className='py-md-5 display-none left-padding10rem1 right-padding10rem1' style={{ padding:'', }} >
    <div className='py-md5 display-none left-padding5rem1 right-padding5rem1' style={{ padding:'', }} >
        <center>
            <div className='bg-ss-secondary rounded10' style={{ boxShadow:'5px 3px 12px 0 rgba(0,0,0,.5)' }}>
                <Row style={{ padding:'25px'}} className=''>
                    <Col md='3' className='border-end border-white fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/rsv-testing-in-chicago-il' className='text-white text-hover-black' style={{ textDecoration:'none'}}>RSV <br/> Testing</Link></Col>

                    <Col md='2' className='border-end border-white fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/influenza-testing-in-chicago-il' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Influenza <br/> Testing</Link></Col>

                    <Col md='4' className='border-end border-white fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/respiratory-pathogen-panel-testing-in-chicago' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Respiratory Pathogen <br/> Panel Testing</Link></Col>

                    <Col md='3' className='border-ed border-bl fs-ss-20 text-montserrat fw-700 text-white text-hover-black' style={{ cursor:'pointer'}}><Link to='/covid-and-rt-pcr-test-in-chicago-il' className='text-white text-hover-black' style={{ textDecoration:'none'}}>Covid-19 <br/> Testing</Link></Col>
                </Row>
            </div>
        </center>
    </div>
    </div>
</div>
  )
}

export default PanelTests